import React from 'react'
import { showLoader } from '../../actions/loader.action'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import './ContainerShell.scss'

const ContainerShell = () => (
  <div className="section ContainerShell__div">
    <div className="columns header">
      {/* <div className="column">{actions.showLoader()}</div> */}
    </div>
    <div className="columns content">
      <div className="column"></div>
    </div>
  </div>
)
ContainerShell.propTypes = {
  actions: PropTypes.shape({
    showLoader: PropTypes.func
  }).isRequired
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        showLoader
      },
      dispatch
    )
  }
}

export default connect(null, mapDispatchToProps)(ContainerShell)
